export var Layouts;

(function (Layouts) {
  Layouts["Split"] = "LAYOUTS/SPLIT";
  Layouts["Fill"] = "LAYOUTS/FILL";
  Layouts["Stack"] = "LAYOUTS/STACK";
})(Layouts || (Layouts = {}));

export var Alignments;

(function (Alignments) {
  Alignments["Center"] = "center";
  Alignments["FlexStart"] = "flex-start";
  Alignments["FlexEnd"] = "flex-end";
  Alignments["Baseline"] = "baseline";
  Alignments["Stretch"] = "stretch";
})(Alignments || (Alignments = {}));

export var SlotTypes;

(function (SlotTypes) {
  SlotTypes["Primary"] = "SLOTTYPES/PRIMARY";
  SlotTypes["Secondary"] = "SLOTTYPES/SECONDARY";
  SlotTypes["Tertiary"] = "SLOTTYPES/TERTIARY";
})(SlotTypes || (SlotTypes = {}));